import { StringType } from "./string.js";
// export interface FileTypeOptions {
//   dirsOnly?: boolean;
//   pattern?: string;
//   ignore?: Array<string>;
// }
/** Integer type. */ export class FileType extends StringType {
  constructor(){
    super();
  }
}
//# sourceMappingURL=file.js.map